function Footer() {
  return (
    <footer className="bg-white dark:bg-gray-900 border-t border-gray-200 dark:border-gray-800 text-gray-600 dark:text-gray-300 py-8 transition-colors">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div>
            <h3 className="text-gray-900 dark:text-white font-bold text-xl mb-4" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
              Is It Taxed
            </h3>
            <p className="text-sm text-gray-500 dark:text-gray-400">
              UK vehicle tax and MOT status checker using official DVLA data.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-gray-900 dark:text-white font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <a href="/dashboard" className="hover:text-gray-900 dark:hover:text-white transition-colors">
                  Dashboard
                </a>
              </li>
              <li>
                <a href="/blog" className="hover:text-gray-900 dark:hover:text-white transition-colors">
                  Blog
                </a>
              </li>
              <li>
                <a href="/widget" className="hover:text-gray-900 dark:hover:text-white transition-colors">
                  Get Widget
                </a>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="text-gray-900 dark:text-white font-semibold mb-4">Legal</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <a href="/privacy" className="hover:text-gray-900 dark:hover:text-white transition-colors">
                  Privacy Policy
                </a>
              </li>
              <li>
                <a href="/terms" className="hover:text-gray-900 dark:hover:text-white transition-colors">
                  Terms of Service
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-gray-900 dark:text-white font-semibold mb-4">Contact</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <a href="/contact" className="hover:text-gray-900 dark:hover:text-white transition-colors">
                  Contact Us
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-200 dark:border-gray-800 mt-8 pt-8 text-center text-sm text-gray-400">
          <p>&copy; {new Date().getFullYear()} Is It Taxed. All rights reserved.</p>
          <p className="mt-2 text-xs">
            Vehicle data provided by DVLA. We are not affiliated with DVLA.
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
